import { render } from "./StringMoney.vue?vue&type=template&id=306be491"
import script from "./StringMoney.vue?vue&type=script&lang=js"
export * from "./StringMoney.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__